module.exports = __webpack_public_path__ + "img/south-bound.b1e43de2.svg";